import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { NhostClient, NhostProvider } from '@nhost/react';
import { ApolloProvider } from '@apollo/client';
import './styles/index.css';
import './i18n';
import App from './App';
import ScrollToTop from './components/ScrollToTop';
import SmoothScrollProvider from './components/layout/SmoothScrollProvider';
import { createApolloClient } from './lib/apollo';
import { initSentry } from './lib/sentry';
import { initPostHog } from './lib/posthog';

// Inicializa observability ANTES de tudo (capta erros de bootstrap)
initSentry();
initPostHog();

const nhost = new NhostClient({
  subdomain: import.meta.env.VITE_NHOST_SUBDOMAIN || 'localhost',
  region: import.meta.env.VITE_NHOST_REGION || 'eu-central-1',
  autoRefreshToken: true,
  autoSignIn: true,
});

const apolloClient = createApolloClient(nhost);

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <NhostProvider nhost={nhost}>
        <ApolloProvider client={apolloClient}>
          <BrowserRouter>
            <SmoothScrollProvider>
              <ScrollToTop />
              <App />
            </SmoothScrollProvider>
          </BrowserRouter>
        </ApolloProvider>
      </NhostProvider>
    </HelmetProvider>
  </StrictMode>,
);
